import React, { useState } from 'react';
import { db } from '../../../firebase';
import { collection, addDoc } from 'firebase/firestore';

const AddPromo = ({ fetchPromos }) => {
    const [formData, setFormData] = useState({
        promo_nom: '',
        promo_code: '',
        promo_valeur: '',
        promo_type: '',
        valid_from: '',
        valid_to: '',
        usage_limit: '',
        statut: true,  // Par défaut à "Activé"
        usage_count: 0
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: name === 'statut' ? value === 'true' : value  // Conversion du statut en booléen
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Convertir les valeurs en types corrects
            const promo_valeur = parseFloat(formData.promo_valeur);
            const usage_count = parseInt(formData.usage_count, 10);
            const usage_limit = parseInt(formData.usage_limit, 10);
            const valid_from = new Date(formData.valid_from);
            const valid_to = new Date(formData.valid_to);

            // Ajouter le nouveau document de promotion à Firestore
            await addDoc(collection(db, 'promos'), {
                promo_nom: formData.promo_nom,
                promo_code: formData.promo_code,
                promo_valeur,
                promo_type: formData.promo_type,
                valid_from: valid_from,
                valid_to: valid_to,
                usage_limit,
                statut: formData.statut,
                usage_count
            });

            // Réinitialiser le formulaire après l'ajout
            setFormData({
                promo_nom: '',
                promo_code: '',
                promo_valeur: '',
                promo_type: '',
                valid_from: '',
                valid_to: '',
                usage_limit: '',
                statut: true,  // Réinitialiser le statut par défaut
                usage_count: 0
            });

            fetchPromos(); // Rafraîchir la liste des promotions après l'ajout
            document.getElementById('addPromoModal').classList.remove('show'); // Fermer le modal
            document.querySelector('.modal-backdrop').remove(); // Supprimer la backdrop
        } catch (error) {
            console.error("Erreur lors de l'ajout de la promotion : ", error);
        }
    };

    return (
        <div className="modal fade" id="addPromoModal" tabIndex="-1" aria-labelledby="addPromoModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg"> {/* Modal large */}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="addPromoModalLabel">Ajouter un code promotionnel</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="promo_nom" className="form-label">Nom</label>
                                    <input type="text" className="form-control" id="promo_nom" name="promo_nom" value={formData.promo_nom} onChange={handleInputChange} required />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="promo_code" className="form-label">Code</label>
                                    <input type="text" className="form-control" id="promo_code" name="promo_code" value={formData.promo_code} onChange={handleInputChange} required />
                                </div>
                                
                                <div className="col-md-6">
                                    <label htmlFor="promo_type" className="form-label">Type</label>
                                    <select className="form-control" id="promo_type" name="promo_type" value={formData.promo_type} onChange={handleInputChange} required>
                                        <option value="">Sélectionner</option>
                                        <option value="percentage">Pourcentage</option>
                                        <option value="flat">Montant fixe</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="promo_valeur" className="form-label">Valeur</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="promo_valeur"
                                        name="promo_valeur"
                                        value={formData.promo_valeur}
                                        onChange={handleInputChange}
                                        required
                                        placeholder={formData.promo_type === 'percentage' ? 'Valeur en %' : 'Valeur en €'}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="valid_from" className="form-label">Date de début</label>
                                    <input type="date" className="form-control" id="valid_from" name="valid_from" value={formData.valid_from} onChange={handleInputChange} required />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="valid_to" className="form-label">Date d'expiration</label>
                                    <input type="date" className="form-control" id="valid_to" name="valid_to" value={formData.valid_to} onChange={handleInputChange} required />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="usage_limit" className="form-label">Limite d'utilisation</label>
                                    <input type="number" className="form-control" id="usage_limit" name="usage_limit" value={formData.usage_limit} onChange={handleInputChange} required />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="statut" className="form-label">Statut</label>
                                    <select className="form-control" id="statut" name="statut" value={formData.statut} onChange={handleInputChange} required>
                                        <option value={true}>Activé</option>
                                        <option value={false}>Désactivé</option>
                                    </select>
                                </div>
                                <div className="col-md-12 text-center mt-3">
                                    <button type="submit" className="btn btn-primary">Ajouter</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddPromo;
